import {
  ensureTab,
  appendRow,
  findRowIndexById,
  updateRow,
  getRows,
} from '../lib/googleSheets';
import { uploadFile } from '../lib/uploadService';

const TAB_NAME = 'Registrations';
const PAID_TAB_NAME = 'PaidCustomers';

const HEADERS = [
  'id',
  'fullName',
  'nickname',
  'phone',
  'email',
  'remarks',
  'paymentMethod',
  'paymentSlipUrl',
  'status',
  'created_at',
  'updated_at',
];

export const registrationService = {
  async getAll() {
    await ensureTab(TAB_NAME, HEADERS);

    const rows = await getRows(`${TAB_NAME}!A2:Z`);

    return rows
      .map((row) => ({
        id: row?.[0] || '',
        fullName: row?.[1] || '',
        nickname: row?.[2] || '',
        phone: row?.[3] || '',
        email: row?.[4] || '',
        remarks: row?.[5] || '',
        paymentMethod: row?.[6] || '',
        paymentSlipUrl: row?.[7] || '',
        status: row?.[8] || '',
        created_at: row?.[9] || '',
        updated_at: row?.[10] || '',
      }))
      .reverse();
  },

  async create(data, file) {
    await ensureTab(TAB_NAME, HEADERS);

    const id = crypto.randomUUID();
    const now = new Date().toISOString();

    let fileUrl = 'N/A';

    if (file && data.paymentMethod === 'bank') {
      fileUrl = await uploadFile(file);
    } else if (data.paymentMethod === 'stripe') {
      fileUrl = 'Stripe Checkout';
    }

    const row = [
      id,
      data.fullName,
      data.nickname,
      data.phone,
      data.email,
      data.remarks || '-',
      data.paymentMethod,
      fileUrl,
      data.paymentMethod === 'stripe'
        ? 'Pending Stripe'
        : 'pending_verification',
      now,
      now,
    ];

    await appendRow(`${TAB_NAME}!A:Z`, row);

    return id;
  },

  async updateStatus(id, newStatus) {
    const rowIndex = await findRowIndexById(TAB_NAME, id);

    if (rowIndex === -1) {
      return false;
    }

    const rows = await getRows(`${TAB_NAME}!A${rowIndex}:Z${rowIndex}`);
    const currentRow = rows[0];

    if (!currentRow) {
      return false;
    }

    if (currentRow[8] === 'Paid' && newStatus === 'Paid') {
      return true;
    }

    const updatedRow = [...currentRow];
    updatedRow[8] = newStatus;
    updatedRow[10] = new Date().toISOString();

    await updateRow(
      `${TAB_NAME}!A${rowIndex}:Z${rowIndex}`,
      updatedRow
    );

    if (newStatus === 'Paid') {
      await this.ensureInPaidTab(updatedRow);
    }

    return true;
  },

  async ensureInPaidTab(rowData) {
    await ensureTab(PAID_TAB_NAME, HEADERS);

    const id = rowData[0];
    const existsInPaid = await findRowIndexById(PAID_TAB_NAME, id);

    if (existsInPaid === -1) {
      await appendRow(`${PAID_TAB_NAME}!A:Z`, rowData);
    }
  },
};